import { SearchInputField } from "@notanumber/nan-component-library";
import { SettingsContext } from "context/SettingsContextProvider";
import useMediaQuery from "hooks/useMediaQuery";
import { fuzzySearch } from "hooks/utils/api_helpers";
import { useRouter } from "next/navigation";
import { useContext, useState } from "react";

const SearchForm = () => {
  const { products } = useContext(SettingsContext);
  const [searchValue, setSearchValue] = useState("");
  const router = useRouter();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const allProducts = products;

  const placeholderText = isDesktop ? "Naar welk product ben je opzoek?" : "Waar bent u naar op zoek?";

  async function submitSearch(searchValue) {
    if (!allProducts) {
      return;
    }
    const result = fuzzySearch(searchValue, allProducts);
    if (result?.length > 1 || result?.length == 0) {
      router.push("/zoeken/" + searchValue);
    } else {
      router.push(result[0]?.item?.post_name);
    }
  }

  return (
    <div className="w-full lg:max-w-[27rem]">
      <form
        onSubmit={(event) => {
          event.preventDefault();
          submitSearch(searchValue);
        }}
      >
        <SearchInputField
          name="search_input_field"
          size="h-12"
          placeholder={placeholderText}
          inputfieldClasses={
            "z-[1] transition-all !text-placeholder placeholder-placeholder relative peer rounded-md text-15 border border-body border-2 focus:border-primary outline-none ring-0 focus:ring-0 focus:ring-offset-0 focus:ring-offset-transparent focus:ring-transparent focus:ring-opacity-0 focus:ring-offset-opacity-0 focus:ring-offset-transparent focus:ring-offset-0 focus:ring-0 focus:outline"
          }
          searchIconClasses="text-primary h-4 w-4 z-[2]"
          autoFocusClasses="bg-white peer rounded-5 !text-placeholder text-15 border-none z-[2]"
          defaultValue={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </form>
    </div>
  );
};

export default SearchForm;
